import { createContext } from 'react';

export type SalesforceChatContextType = {
    isChatEnabled: boolean;
    isError: boolean;
    isReady: boolean;
    logoutSalesforceChat: () => void;
    openChat: () => void;
};

const SalesforceChatContext = createContext<SalesforceChatContextType | null>(null);

export default SalesforceChatContext;
